import { IconButton, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

type ItemLocatorProps = {
  index: number
  count: number
  onChange(newIndex: number): void
}

export const ItemLocator = ({ index, count, onChange }: ItemLocatorProps) => {
  const { t } = useTranslation('@cibo/ui/ItemLocator')

  return (
    <Stack direction="row" alignItems="center">
      <IconButton
        onClick={() => {
          index > 0 && onChange(index - 1)
        }}
        disabled={index === 0}
      >
        <NavigateBeforeIcon />
      </IconButton>

      <Typography>{t('whichItem', { ordinal: index + 1, count })}</Typography>

      <IconButton
        onClick={() => index < count - 1 && onChange(index + 1)}
        disabled={index === count - 1}
      >
        <NavigateNextIcon />
      </IconButton>
    </Stack>
  )
}
